"use client";

import { useEffect, useState } from "react";
import { type TextSize, applyTextSize, getTextSize, nextTextSize } from "@/lib/textSize";

const LABEL: Record<number, string> = {
  1: "обычный",
  1.125: "крупнее",
  1.25: "самый крупный",
};

/** Text size, in the chrome beside volume — where a player looks for it. */
export function TextSizeButton() {
  const [size, setSize] = useState<TextSize>(1);

  useEffect(() => {
    const stored = getTextSize();
    setSize(stored);
    applyTextSize(stored);
  }, []);

  return (
    <button
      type="button"
      onClick={() => {
        const next = nextTextSize(size);
        setSize(next);
        applyTextSize(next);
      }}
      aria-label={`Размер текста: ${LABEL[size]}. Нажмите, чтобы сменить`}
      title="Размер текста"
      className="flex cursor-pointer items-baseline gap-0.5 rounded-full border-4 border-outline bg-card px-3 py-2 font-display font-extrabold text-ink-soft transition-colors hover:text-ink focus-visible:outline-3 focus-visible:outline-offset-2 focus-visible:outline-sky"
    >
      <span className="text-[0.7rem] leading-none">А</span>
      <span className={`leading-none ${size === 1 ? "text-[0.85rem]" : size === 1.125 ? "text-base" : "text-lg"}`}>
        А
      </span>
    </button>
  );
}
